/**
 * MRB Book Reader — the book-samples page's entry point over the shared
 * flip-book engine in assets/mrb-reader-core.js (PDF.js + StPageFlip inside
 * the theme <dialog-component>; see that file for the full architecture).
 *
 * Cards in sections/mrb-book-samples.liquid carry data-title/data-pdf/
 * data-product; the engine wires their [data-bs-open] buttons itself. Keeping
 * this filename stable means the section's script tag never changes.
 */

// Importmap alias (snippets/scripts.liquid), NOT a relative path: relative
// module imports resolve to version-less CDN URLs, which Shopify serves from
// stale caches after theme pushes. The alias carries asset_url's ?v=.
import { BookReader } from '@mrb/reader-core';

for (const root of document.querySelectorAll('[data-bs-root]')) {
  if (root.dataset.bsInit) continue;
  root.dataset.bsInit = '1';
  new BookReader(root);
}
